import gql from "graphql-tag";

// Define the GraphQL mutation
export const SEND_VERIFICATION_SMS_LINK = gql`
  mutation SendVerificationSms($phoneNumber: String!, $verificationUrl: String!) {
    SendVerificationSms(phoneNumber: $phoneNumber, verificationUrl: $verificationUrl) {
      status
      errorMessage
    }
  }
`;

// Redux-thunk style action to call the mutation
export function sendVerificationSmsLink({ phoneNumber, verificationUrl }) {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation: SEND_VERIFICATION_SMS_LINK,
        variables: { phoneNumber, verificationUrl },
      });
      return data.SendVerificationSms;
    } catch (error) {
      return { status: '400', errorMessage: error.message };
    }
  };
}
